var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBolt = function SvgBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m14.982 9.315 1.328-5.047.49-1.868-1.544 1.159L4.8 11.4v1.8l3.311.221 1.219.083-.311 1.181-1.328 5.048-.491 1.867 1.545-1.159L19.2 12.6v-1.8l-3.312-.221-1.218-.083zm3.019 2.606V12l-8.764 6.57 1.252-4.763.372-1.406-1.448-.097-3.412-.229v-.079l8.763-6.566-1.252 4.763-.371 1.406 1.451.097 3.412.229z"
  })));
};
export default SvgBolt;